// extracted by mini-css-extract-plugin
module.exports = {"ContainerTraditionalResume":"ProjectsPage_ContainerTraditionalResume__3oGim","DarkTheme":"ProjectsPage_DarkTheme__h-pQj","LightTheme":"ProjectsPage_LightTheme__3TpIy"};